module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_01@2x-10aedbaab756c26faa0e90f41026baa6.webp";